import { BaseExporter } from '../base/BaseExporterMapping.js';

export default class DanishExporter extends BaseExporter {
    export() {
        const baseData = this.getBaseData();
        const metrics = this.getCampaignMetrics();

        const exportData = {
            ...baseData,
            'Delivered VAC': metrics.deliveredEAVAC,
            'Promise Screens': metrics.estimatedPanels,
            'Delivered Screens': metrics.deliveredPanels,
            'Promised Plays': metrics.estimatedPlays,
            'Delivered Plays': metrics.deliveredPlays,
            'PO number': this.orderline?.clientOrderNumber || ""
        };

        return this.filterByPromiseType(exportData, baseData);
    }
}